<template>
    <div id="contact">
        <Breadcrumb :currentPage="breadcrumbName" :items="breadcrumbItems" :showAddBtn="false"/>
        <v-layout row wrap>
            <!-- Information -->
            <v-flex xs12 md8>
                <v-card class="mx-auto same-height">
                    <v-card-title class="title">Info company</v-card-title>
                    <div class="content">
                        <div class="item">
                            <div class="contact-info-div">
                                <b>Company</b>
                                <p>Vitalify Asia Co., Ltd</p>
                            </div>
                            <div class="contact-info-div">
                                <b>Representative's name</b>
                                <p>Takayuki Sakurai</p>
                            </div>
                            <div class="contact-info-div">
                                <b>Location</b>
                                <p>
                                    224A-224B Dien Bien Phu Street, Ward 7, District 3,
                                    <br>
                                    Ho Chi Minh city, Vietnam
                                    <br>
                                    Tel (028) 3932 6293
                                    <br>
                                    Fax (028) 3932 6294
                                    <br>
                                </p>
                            </div>

                            <div class="contact-info-div">
                                <b>Establishment</b>
                                <p>May 2008</p>
                            </div>

                            <div class="contact-info-div">
                                <b>Capital</b>
                                <p>$100,000 (USD)</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="contact-info-div">
                                <b>Business contents</b>
                                <p>AI and Mobile/Web software development</p>
                            </div>

                            <div class="contact-info-div">
                                <b>Number of employees</b>
                                <p>100 Vietnamese staff and 9 Japanese staff</p>
                            </div>

                            <div class="contact-info-div">
                                <b>Head Office in Japan</b>
                                <p>
                                    Vitalify Inc 〒150-0021 Ebisunishi Asutourubiru 8F 1-9-6, Shibuya, Tokyo
                                    <br>
                                    TEL 03-5428-6346
                                    <br>
                                    FAX 03-3461-6347
                                    <br>
                                    https://vitalify.jp/
                                    <br>
                                </p>
                            </div>
                        </div>
                        <div class="clear-fix"></div>
                    </div>
                </v-card>
            </v-flex>
            <!-- Contact form -->
            <v-flex xs12 md4>
                <div class="form">
                    <v-card class="mx-auto same-height">
                        <v-card-title class="title">Contact with us</v-card-title>
                        <v-form ref="form" v-model="form.valid">
                            <div class="form-content">
                                <div class="contact-label-div">
                                    <label class="contact-label">Full name</label>
                                </div>
                                <v-text-field
                                    v-model="form.fullName"
                                    single-line
                                    solo
                                    :rules="rules.fullName"
                                >

                                </v-text-field>

                                <div class="contact-label-div">
                                    <label class="contact-label">Mobile number</label>
                                </div>
                                <v-text-field
                                    v-model="form.phone"
                                    single-line
                                    required
                                    solo
                                    :rules="rules.mobile"
                                >
                                </v-text-field>

                                <div class="contact-label-div">
                                    <label class="contact-label" type="email">Email</label>
                                </div>
                                <v-text-field
                                    v-model="form.email"
                                    single-line
                                    solo
                                    required
                                    :rules="rules.email"
                                >
                                </v-text-field>
                            </div>
                        </v-form>
                        <v-card-actions class="card-action">
                            <v-btn
                                id="send-btn"
                                :disabled="!form.valid"
                                @click="sendContact"
                                color="primary"
                                :loading="loading">Send now
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-flex>
            <!-- Information -->
        </v-layout>
    </div>
</template>

<script>
    import Breadcrumb from '../components/common/Breadcrumb.vue';
    import {ruleEmail, ruleFullName, rulePhone} from "../utils/validate-rules";
    import { mapActions } from 'vuex'
    import mailService  from '../services/mailService';

    export default {
        name: "contact",
        data() {
            return {
                breadcrumbName: 'Contact',
                breadcrumbItems: [
                    {
                        text: 'Contact',
                        disabled: true,
                        to: {path: '/contact'},
                        exact: true,
                    },
                ],
                form: {
                    valid: false,
                    fullName: "",
                    phone: "",
                    email: ""
                },
                rules: {
                    mobile: rulePhone,
                    fullName: ruleFullName,
                    email: ruleEmail,
                },
                loading: false,

            }
        },
        components: {
            Breadcrumb,
        },
        methods: {
            ...mapActions('app',[
                'initSnackbar'
            ]),
            resetForm() {
                this.$refs.form.reset();
            },
            sendContact: function () {
                if (this.$refs.form.validate()) {
                    const data = {
                        fullName: this.form.fullName,
                        phoneNumber: this.form.phone,
                        email: this.form.email,
                    };
                    this.loading = true;

                    mailService.sendMail(data).then(() => {
                        this.loading = false;
                        this.resetForm();
                        this.initSnackbar({
                            message: 'Thank you!Your request has sent!We will contact you as soon as possible!',
                            color: 'success'
                        });
                    }).catch((error) => {
                        this.loading = false;
                        this.initSnackbar({
                            message: `${error}`,
                            color: 'error'
                        });
                    });
                }
            }
        }
    }
</script>

<style scoped>

    .contact-label-div {
        text-align: left;
        margin-bottom: 1%;
    }

    .contact-info-div {
        text-align: left;
    }


    #send-btn {
        min-width: 50%;
        border-radius: 3px
    }

    .title {
        font-size: 20px;
        font-weight: bold;
    }

    .form {
        min-height: 400px;
    }

    .content, .form-content {
        padding: 16px;
    }

    .content .item {
        width: 45%;
        float: left;
    }

    .content .item:first-child {
        margin-right: 5%;
        border-right: 1px solid #ebebeb;
    }

    .card-action {
        display: flex;
        justify-content: center;
    }

    .clear-fix {
        clear: both;
    }

    .same-height {
        min-height: 70vh;
    }
</style>
